import { RSAA } from 'redux-api-middleware';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';

const host = process.env.BACKEND_URL;
const entity = 'CERTIFICATION';

export const FORM_NAME = `${entity}/FORM`;

// Init state
const initialState = {
  list: [],
  users: [],
};

export const types = {
  SET_LIST: `${entity}/SET_LIST`,
  RESET_LIST: `${entity}/RESET_LIST`,
  SET_USERS_LIST: `${entity}/SET_USERS_LIST`,
  REQUEST_LIST: `${entity}/REQUEST_LIST`,
  REQUEST_USERS_LIST: `${entity}/REQUEST_USERS_LIST`,
  REQUEST_CREATE: `${entity}/REQUEST_CREATE`,
  REQUEST_EDIT: `${entity}/REQUEST_EDIT`,
  REQUEST_DELETE: `${entity}/REQUEST_DELETE`,
};

// { value: 'teacher', label: 'Для педагогов' },
// { value: 'student', label: 'Для детей' },

export const settings = {
  student: {
    '13': [
      {
        id: 'AddA',
        level: 'LEVEL_13',
        type: 'Five',
        title: 'FIVE',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_1',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_13',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_2',
        time: 10,
      },
      {
        id: 'AddC',
        level: 'LEVEL_13',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_3',
        time: 10,
      },
      {
        id: 'AddD',
        level: 'LEVEL_13',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddE',
        level: 'LEVEL_13',
        type: 'Card',
        title: 'CARD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_5',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_13',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '12': [
      {
        id: 'AddA',
        level: 'LEVEL_12',
        type: 'Ten',
        title: 'TEN',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_1',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_12',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_2',
        time: 10,
      },
      {
        id: 'AddC',
        level: 'LEVEL_12',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_3',
        time: 10,
      },
      {
        id: 'AddD',
        level: 'LEVEL_12',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddE',
        level: 'LEVEL_12',
        type: 'Card',
        title: 'CARD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_5',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_12',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '11': [
      {
        id: 'AddA',
        level: 'LEVEL_11',
        type: 'Ten',
        title: 'TEN',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_1',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_11',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_2',
        time: 10,
      },
      {
        id: 'AddC',
        level: 'LEVEL_11',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_3',
        time: 10,
      },
      {
        id: 'AddD',
        level: 'LEVEL_11',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddE',
        level: 'LEVEL_11',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_5',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_11',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '10': [
      {
        id: 'AddA',
        level: 'LEVEL_10',
        type: 'Ten',
        title: 'TEN',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_1',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_10',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_2',
        time: 10,
      },
      {
        id: 'AddC',
        level: 'LEVEL_10',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_3',
        time: 10,
      },
      {
        id: 'AddD',
        level: 'LEVEL_10',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddE',
        level: 'LEVEL_10',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_5',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_10',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '9': [
      {
        id: 'Multi',
        level: 'LEVEL_9',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_1',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_9',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_2',
        time: 10,
      },
      {
        id: 'AddC',
        level: 'LEVEL_9',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_3',
        time: 10,
      },
      {
        id: 'AddD',
        level: 'LEVEL_9',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddE',
        level: 'LEVEL_9',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_5',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_9',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '8': [
      {
        id: 'AddA',
        level: 'LEVEL_8',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_1',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_8',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_8_SECTION_2',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_8',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION_LEVEL_8_SECTION_3',
        time: 10,
      },
      {
        id: 'AddB',
        level: 'LEVEL_8',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddC',
        level: 'LEVEL_8',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_5',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_8',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '7': [
      {
        id: 'AddA',
        level: 'LEVEL_7',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_1',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_7',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_7_SECTION_2',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_7',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION_LEVEL_7_SECTION_3',
        time: 10,
      },
      {
        id: 'AddB',
        level: 'LEVEL_7',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddC',
        level: 'LEVEL_7',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_5',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_7',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '6': [
      {
        id: 'AddA',
        level: 'LEVEL_6',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_1',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_6',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_2',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_6',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION_LEVEL_6_SECTION_3',
        time: 10,
      },
      {
        id: 'AddB',
        level: 'LEVEL_6',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'MultiB',
        level: 'LEVEL_6',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_5',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_6',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
  },
  teacher: {
    '1': [
      {
        id: 'AddA',
        level: 'LEVEL_1',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_1',
        time: 10,
      },
      {
        id: 'AddB',
        level: 'LEVEL_1',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_2',
        time: 10,
      },
      {
        id: 'AddC',
        level: 'LEVEL_1',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_3',
        time: 10,
      },
      {
        id: 'AddD',
        level: 'LEVEL_1',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddE',
        level: 'LEVEL_1',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_5',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_1',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '2': [
      {
        id: 'AddA',
        level: 'LEVEL_2',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_1',
        time: 10,
      },
      {
        id: 'AddB',
        level: 'LEVEL_2',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_2',
        time: 10,
      },
      {
        id: 'AddC',
        level: 'LEVEL_2',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_3',
        time: 10,
      },
      {
        id: 'AddD',
        level: 'LEVEL_2',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'AddE',
        level: 'LEVEL_2',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_5',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_2',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '3': [
      {
        id: 'AddA',
        level: 'LEVEL_3',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_1',
        time: 2,
      },
      {
        id: 'AddB',
        level: 'LEVEL_3',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_2',
        time: 2,
      },
      {
        id: 'AddC',
        level: 'LEVEL_3',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_3',
        time: 10,
      },
      {
        id: 'AddD',
        level: 'LEVEL_3',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_4',
        onlyMental: true,
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_3',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
  },
  mental: {
    '2': [
      {
        id: 'AddA',
        level: 'LEVEL_2',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'Multi',
        level: 'LEVEL_2',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'MENTAL_ARITHMETIC_MULTIPLICATION',
        time: 3,
      },
      {
        id: 'Division',
        level: 'LEVEL_2',
        type: 'Division',
        title: 'DIVISION',
        desc: 'MENTAL_ARITHMETIC_DIVISION',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_2',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
        time: 4,
      },
    ],
    '3': [
      {
        id: 'AddA',
        level: 'LEVEL_3',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'Multi',
        level: 'LEVEL_3',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'MENTAL_ARITHMETIC_MULTIPLICATION',
        time: 3,
      },
      {
        id: 'Division',
        level: 'LEVEL_3',
        type: 'Division',
        title: 'DIVISION',
        desc: 'MENTAL_ARITHMETIC_DIVISION',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_3',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
        time: 4,
      },
    ],
    '4': [
      {
        id: 'AddA',
        level: 'LEVEL_4',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'Multi',
        level: 'LEVEL_4',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'MENTAL_ARITHMETIC_MULTIPLICATION',
        time: 3,
      },
      {
        id: 'Division',
        level: 'LEVEL_4',
        type: 'Division',
        title: 'DIVISION',
        desc: 'MENTAL_ARITHMETIC_DIVISION',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_4',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
        time: 4,
      },
    ],
    '5': [
      {
        id: 'AddA',
        level: 'LEVEL_5',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'Multi',
        level: 'LEVEL_5',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'MENTAL_ARITHMETIC_MULTIPLICATION',
        time: 3,
      },
      {
        id: 'Division',
        level: 'LEVEL_5',
        type: 'Division',
        title: 'DIVISION',
        desc: 'MENTAL_ARITHMETIC_DIVISION',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_5',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
        time: 4,
      },
    ],
    '6': [
      {
        id: 'AddA',
        level: 'LEVEL_6',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'Multi',
        level: 'LEVEL_6',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'MENTAL_ARITHMETIC_MULTIPLICATION',
        time: 3,
      },
      {
        id: 'Division',
        level: 'LEVEL_6',
        type: 'Division',
        title: 'DIVISION',
        desc: 'MENTAL_ARITHMETIC_DIVISION',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_6',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
        time: 4,
      },
    ],
    '7': [
      {
        id: 'AddA',
        level: 'LEVEL_7_A',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_7_B',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_7',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
        time: 3,
      },
    ],
    '8': [
      {
        id: 'AddA',
        level: 'LEVEL_8_A',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_8_B',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_8',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
        time: 3,
      },
    ],
    '9': [
      {
        id: 'AddA',
        level: 'LEVEL_9_A',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_9_B',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_9',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
        time: 3,
      },
    ],
    '10': [
      {
        id: 'AddA',
        level: 'LEVEL_10_A',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'AddB',
        level: 'LEVEL_10_B',
        type: 'Add',
        title: 'ADD',
        desc: 'MENTAL_ARITHMETIC_ADD',
        time: 3,
      },
      {
        id: 'L',
        level: 'LEVEL_10',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
  },
  abacus: {
    '3': [
      {
        id: 'AddA',
        level: 'LEVEL_3',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_3',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_3',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_3',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '4': [
      {
        id: 'AddA',
        level: 'LEVEL_4',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_4',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_4',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_4',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '5': [
      {
        id: 'AddA',
        level: 'LEVEL_5',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_5',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_5',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_5',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '6': [
      {
        id: 'AddA',
        level: 'LEVEL_6',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_6',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_6',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_6',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '7': [
      {
        id: 'AddA',
        level: 'LEVEL_7',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_7',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_7',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_7',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '8': [
      {
        id: 'AddA',
        level: 'LEVEL_8',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'Multi',
        level: 'LEVEL_8',
        type: 'Multi',
        title: 'MULTIPLICATION',
        desc: 'ABACUS_ARITHMETIC_MULTIPLICATION',
        time: 10,
      },
      {
        id: 'Division',
        level: 'LEVEL_8',
        type: 'Division',
        title: 'DIVISION',
        desc: 'ABACUS_ARITHMETIC_DIVISION',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_8',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '9': [
      {
        id: 'AddA',
        level: 'LEVEL_9',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_9',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '10': [
      {
        id: 'AddA',
        level: 'LEVEL_10',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_10',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '11': [
      {
        id: 'AddA',
        level: 'LEVEL_11',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_11',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
    '12': [
      {
        id: 'AddA',
        level: 'LEVEL_12',
        type: 'Add',
        title: 'ADD',
        desc: 'ABACUS_ARITHMETIC_ADD',
        time: 10,
      },
      {
        id: 'L',
        level: 'LEVEL_12',
        type: 'RESULT',
        title: 'RESULT',
        desc: 'RESULT',
      },
    ],
  },
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LIST:
    case types.SET_USERS_LIST:
      return {
        ...state,
        [action.meta]: action.payload,
      };
    case types.RESET_LIST:
      return {
        ...state,
        list: [],
      };
    default:
      return state;
  }
};

// Actions
export const fetchUsersList = () => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/users`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_USERS_LIST,
      },
    })),
  },
});

export const fetchList = formData => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}?${Object.entries(formData)
      .reduce((acc, [key, value]) => {
        acc.push(`${key}=${value}`);
        return acc;
      }, [])
      .join('&')}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_LIST,
      },
    })),
  },
});

export const fetchCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_CREATE,
      },
    })),
  },
});

export const fetchEdit = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_EDIT,
      },
    })),
  },
});

export const fetchDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_DELETE,
      },
    })),
  },
});

const resetList = () => ({
  type: types.RESET_LIST,
});

export const actions = {
  fetchList,
  fetchUsersList,
  fetchCreate,
  fetchEdit,
  fetchDelete,
  resetList,
};

export default reducer;
